import {IColumnDefOf, IUiGridConstants} from "ui-grid";
import {AdviserEquityPositionViewModel} from "../../models/AdviserEquityPositionViewModel";
import IUiGridTreeBaseConstants = uiGrid.treeBase.IUiGridTreeBaseConstants;

export default function(uiGridConstants: IUiGridConstants, uiGridTreeBaseConstants: IUiGridTreeBaseConstants): ReadonlyArray<IColumnDefOf<AdviserEquityPositionViewModel>> {
    return [
        {
            name: "org",
            field: "org",
            type: "string",
            cellTooltip: true,
            visible: false,
            groupingShowAggregationMenu: false,
            displayName: "equity_positions_search.ORGANISATION",
            width: "*",
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            filter: {
                condition: uiGridConstants.filter.CONTAINS
            }
        },
        {
            name: "branch",
            field: "branch",
            type: "string",
            groupingShowAggregationMenu: false,
            displayName: "equity_positions_search.BRANCH",
            width: "*",
            cellTooltip: true,
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            filter: {
                condition: uiGridConstants.filter.CONTAINS
            }
        },
        {
            name: "adviser",
            field: "adviser",
            type: "string",
            cellTooltip: true,
            groupingShowAggregationMenu: false,
            displayName: "equity_positions_search.ADVISER",
            width: "*",
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            filter: {
                condition: uiGridConstants.filter.CONTAINS
            }
        },
        {
            name: "accountNumber",
            type: "string",
            displayName: "equity_positions_search.ACCOUNT_NUMBER",
            width: "**",
            cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a ui-sref=\"portfolio({portfolioId : row.entity.portfolioId})\">{{ row.entity['accountNumber'] }}</a></div>",
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            cellTooltip: true,
            groupingShowAggregationMenu: false,
            filter: {
                condition: uiGridConstants.filter.CONTAINS
            }
        },
        {
            name: "accountName",
            type: "string",
            displayName: "equity_positions_search.ACCOUNT_NAME",
            width: "**",
            cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a ui-sref=\"portfolio({portfolioId : row.entity.portfolioId})\">{{ row.entity['accountName'] }}</a></div>",
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            cellTooltip: true,
            groupingShowAggregationMenu: false,
            filter: {
                condition: uiGridConstants.filter.CONTAINS
            }
        },
        {
            name: "code",
            type: "string",
            cellTooltip: true,
            groupingShowAggregationMenu: false,
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            visible: true,
            displayName: "equity_positions_search.CODE",
            width: "*",
            cellTemplate: `<div class="ui-grid-cell-contents"><tf-security-link security="row.entity"></tf-security-link><div>`
        },
        {
            name: "quantity",
            type: "number",
            displayName: "equity_positions_search.QUANTITY",
            width: "*",
            cellTooltip: true,
            headerCellClass: "gridNumber",
            cellClass: "gridNumber",
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            enableGrouping: false,
            filter: {
                condition: uiGridConstants.filter.LESS_THAN
            },
            footerCellClass: "gridNumber",
            footerCellFilter: "number:0",
            cellFilter: "number:0",
            cellTemplate: `<div class="ui-grid-cell-contents"><span ng-class=\"{sell : COL_FIELD < 0}\"><tf-order-entry-link security="row.entity" quantity="row.entity.quantity" side="'SELL'" account-id="row.entity.portfolioId">{{COL_FIELD CUSTOM_FILTERS}}</tf-order-entry-link></span><div>`,
            aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
            treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
            customTreeAggregationFinalizerFn: (aggregation: any) => {
                aggregation.rendered = aggregation.value;
            }
        },
        {
            name: "averagePrice",
            type: "number",
            headerCellTemplate: "tf/uiGridHeaderCell",
            enableGrouping: false,
            cellTooltip: true,
            displayName: "equity_positions_search.AVERAGE_PRICE",
            width: "*",
            headerCellClass: "gridNumber",
            headerCellFilter: "translate",
            cellClass: "gridNumber",
            cellFilter: "number : 3"
        },
        {
            name: "last",
            type: "number",
            displayName: "equity_positions_search.LAST",
            width: "*",
            headerCellClass: "gridNumber",
            headerCellFilter: "translate",
            cellClass: "gridNumber",
            enableFiltering: false,
            cellTemplate: `<div class="ui-grid-cell-contents"><span tf-quote-change="row.entity.quote">{{COL_FIELD | strategyPrice : row.entity.quote.strategy}}</span><div>`,
            visible: true
        },
        {
            name: "marketValue",
            type: "number",
            displayName: "equity_positions_search.MARKET_VALUE",
            cellFilter: "ledger:0",
            footerCellFilter: "ledger:0",
            footerCellClass: (grid, gridRow, gridCol, rowRenderIndex, colRenderIndex) => {
                return `gridNumber ${+gridCol.getAggregationValue() < 0 ? "negative" : "positive"}`;
            },
            width: "*",
            headerCellClass: "gridNumber",
            headerCellFilter: "translate",
            cellClass: (grid, gridRow, gridCol, rowRenderIndex, colRenderIndex) => {
                if (gridRow?.entity.marketValue == null) {
                    return "gridNumber not-available";
                } else if (gridRow.entity.marketValue === 0) {
                    return "gridNumber";
                } else if (gridRow.entity.marketValue < 0) {
                    return "gridNumber negative";
                } else {
                    return "gridNumber positive";
                }
            },
            enableFiltering: false,
            visible: true,
            aggregationType: uiGridConstants.aggregationTypes.sum,
            aggregationHideLabel: true
        },
        {
            name: "pnl",
            type: "number",
            displayName: "equity_positions_search.PNL",
            width: "*",
            enableGrouping: false,
            footerCellClass: "gridNumber", footerCellFilter: "ledger",
            cellFilter: "ledger", cellTooltip: true,
            headerCellClass: "gridNumber",
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            cellClass: "gridNumber",
            cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : COL_FIELD < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
            aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
            treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
            customTreeAggregationFinalizerFn: (aggregation: any) => {
                aggregation.rendered = aggregation.value;
            }
        },
        {
            name: "pnlPercent",
            type: "number",
            displayName: "equity_positions_search.PNL_PERCENT",
            cellFilter: "percentage : 2 | otherwise: 'N/A'",
            width: "*",
            headerCellClass: "gridNumber",
            headerCellFilter: "translate",
            cellClass: (grid, gridRow, gridCol, rowRenderIndex, colRenderIndex) => {
                if (gridRow?.entity.pnlPercent == null) {
                    return "gridNumber not-available";
                } else if (gridRow.entity.pnlPercent === 0) {
                    return "gridNumber";
                } else if (gridRow.entity.pnlPercent < 0) {
                    return "gridNumber negative";
                } else {
                    return "gridNumber positive";
                }
            },
            enableFiltering: false,
            visible: true
        },
        {
            name: "todayPnl",
            type: "number",
            displayName: "equity_positions_search.TODAY_PNL",
            footerCellClass: "gridNumber",
            footerCellFilter: "ledger",
            width: "*",
            enableGrouping: false,
            cellFilter: "ledger", cellTooltip: true,
            headerCellClass: "gridNumber",
            headerCellTemplate: "tf/uiGridHeaderCell",
            headerCellFilter: "translate",
            cellClass: "gridNumber",
            cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : COL_FIELD < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
            aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
            treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
            customTreeAggregationFinalizerFn: (aggregation: any) => {
                aggregation.rendered = aggregation.value;
            }
        },
        {
            name: "changePercent",
            type: "number",
            displayName: "equity_positions_search.CHANGE_PERCENT",
            cellFilter: "percentage:2",
            width: "*",
            headerCellClass: "gridNumber",
            headerCellFilter: "translate",
            cellClass: (grid, gridRow, gridCol, rowRenderIndex, colRenderIndex) => {
                if (gridRow?.entity.changePercent == null) {
                    return "gridNumber not-available";
                } else if (gridRow.entity.changePercent === 0) {
                    return "gridNumber";
                } else if (gridRow.entity.changePercent < 0) {
                    return "gridNumber negative";
                } else {
                    return "gridNumber positive";
                }
            },
            enableFiltering: false,
            visible: true
        }
    ];
}
